import { useState } from "react";

import styles from "@styles/forms-flow/forms.module.scss";

import classNames from "classnames/bind";

import { Button } from "@components";

const css = classNames.bind(styles);

export const DaysWeek = ({ data, onApply }) => {
  const [selectedDays, setSelectedDays] = useState(
    data.type == "DAYS_WEEK" ? data.value || [] : []
  );

  const isSelectedDay = (day) => {
    return selectedDays.includes(day);
  };

  const selectDaysWeek = (day) => {
    let tempArr = selectedDays;
    const index = tempArr.indexOf(day);

    if (index > -1) {
      tempArr = tempArr.filter((item) => item !== day);
    } else tempArr = [...tempArr, day];

    setSelectedDays(tempArr);
  };

  const days = [
    {
      id: 1,
      day: "D",
    },
    {
      id: 2,
      day: "S",
    },
    {
      id: 3,
      day: "T",
    },
    {
      id: 4,
      day: "Q",
    },
    {
      id: 5,
      day: "Q",
    },
    {
      id: 6,
      day: "S",
    },
    {
      id: 7,
      day: "S",
    },
  ];

  return (
    <div className={styles.daysWeek}>
      <p className={styles.label}>Defina os dias da semana</p>

      <div className={styles.days}>
        {days.map((day, _i) => (
          <div
            className={css({ day: true, isSelected: isSelectedDay(day.id) })}
            onClick={() => selectDaysWeek(day.id)}
          >
            {day.day}
          </div>
        ))}
      </div>

      <div className={styles.footer}>
        <Button
          onClick={() => onApply({ weekDays: selectedDays })}
          className="w-100"
          design="primary"
        >
          Aplicar
        </Button>
      </div>
    </div>
  );
};
